<template>
    <div class="apply-page-container">
        <!-- loading -->
        <div v-if="loading" class="loading-container">
            <DotFadeSpinner />
            <div class="loading-message">인증중입니다..</div>
        </div>

        <!-- main contents -->
        <ApplyHeader :leftButtonHandler="goBackHandler" pageName="intro" :goHomeHandler="goHomeHandler" />
        <div v-if="!loading" class="apply-page">
            <div class="section-one">
                <div class="title-box">
                    <img class="icon" :src="require(`@/assets/images/icons/id-card.svg`)" />
                    <div class="title">심사합격률</div>
                </div>
                <div v-if="version === 0" class="percent-box version-one">
                    <div class="background" />
                    <div class="number">38</div>
                    <div class="symbol">%</div>
                </div>
                <div v-if="version === 1" class="percent-box version-two">
                    <div class="number">38</div>
                    <div class="symbol">%</div>
                </div>

                <div class="desc">*{{ date_two_days_ago }} 기준</div>
            </div>

            <div class="section-two">
                <!-- <div class="btn-desc">양질의 매칭풀 퀄리티를 위해<br />가입 심사 제도를 운영합니다.</div> -->
                <div class="btn-desc">
                    <p>• 매칭풀 퀄리티를 위해 가입 심사를 진행합니다.</p>
                    <p>• 본인 인증 후 가입 심사 신청이 가능하며, 가입 심사에는 약 1~2분 정도 소요됩니다.</p>
                </div>
                <!-- <button @click="goNextPage">시작하기</button> -->
                <button class="btn" @click="goNextPage">
                    <p class="label f-regular">가입 심사받기</p>
                </button>

                <div class="btn-desc-sec">
                    본인인증을 완료되면 <span class="link" @click="openLink('service')">이용약관</span>,<br />
                    <span class="link" @click="openLink('privacy')">개인정보처리방침</span>에 동의하는 것으로
                    간주합니다.
                </div>
            </div>

            <!-- <div class="section-three">
                <div class="title">실시간 심사현황</div>
                <div class="list-box">현황 list</div>
            </div> -->
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'
import Vue from 'vue'
import axios from '@/modules/axios'
import ApplyHeader from './ApplyHeader.vue'
import { sendMetaTransition } from '@/services/meta-event'

let authPopup = null

export default {
    name: 'FirstPage',
    components: {
        ApplyHeader,
    },
    watch: {
        '$store.getters.niceData': {
            handler(newVal) {
                if (!newVal) return

                this.finish(newVal)
            },
            deep: true,
        },
    },
    data: () => ({
        version: 0,
        loading: false,
        date_two_days_ago: '',

        authPopup: null,
        popupCheckInterval: null,
        returnedFromPopup: false,

        lastAuthRid: null,

        authStatusPollInterval: null,
        authStatusPollCount: 0,

        hasGenderSource: null,
        hasFinished: false,
    }),
    mounted() {
        // url에 utm 관련 파라미터들 localstorage에 저장
        console.log('this.$route.query', this.$route.query)

        // facebook fbc fbp 값 localstorage에 저장. 값은 경우에 따라 바뀔 수 있음.
        const fbc = this.$route.query.fbc
        const fbp = this.$route.query.fbp
        if (fbc) localStorage.setItem('_fbc', fbc)
        if (fbp) localStorage.setItem('_fbp', fbp)

        const INTRO_VER = this.$route.query.intro_ver
        if (INTRO_VER) localStorage.setItem('INTRO_VER', INTRO_VER)
        if (INTRO_VER === 'passrate_v1') {
            this.version = 0
        }
        const LANDING_VER = this.$route.query.landing_ver
        if (LANDING_VER) localStorage.setItem('LANDING_VER', LANDING_VER)

        const GENDER_SOURCE = this.$route.query.gen
        if (GENDER_SOURCE) {
            this.hasGenderSource = GENDER_SOURCE
            localStorage.setItem('GENDER_SOURCE', GENDER_SOURCE)
        }

        const UTM_CHANNEL = this.$route.query.utm_channel
        if (UTM_CHANNEL) localStorage.setItem('UTM_CHANNEL', UTM_CHANNEL)
        const UTM_MEDIUM = this.$route.query.utm_medium
        if (UTM_MEDIUM) localStorage.setItem('UTM_MEDIUM', UTM_MEDIUM)
        const UTM_CAMPAIGN = this.$route.query.utm_campaign
        if (UTM_CAMPAIGN) localStorage.setItem('UTM_CAMPAIGN', UTM_CAMPAIGN)
        const UTM_ADSET = this.$route.query.utm_adset
        if (UTM_ADSET) localStorage.setItem('UTM_ADSET', UTM_ADSET)
        const UTM_CONTENT = this.$route.query.utm_content || this.$route.query.ad_creative
        if (UTM_CONTENT) localStorage.setItem('UTM_CONTENT', UTM_CONTENT)

        const DEVICE_ID = Number(new Date()) + Math.random()
        if (!localStorage.getItem('DEVICE_ID')) localStorage.setItem('DEVICE_ID', DEVICE_ID)

        // 본인인증 결과 받기
        window.addEventListener('message', this.handleAuthMessage)
        window.addEventListener('focus', this.handleWindowFocus)

        this.date_two_days_ago = this.getTwoDaysAgoFormattedDate()
    },
    // computed: {

    // },
    // created() {

    // },
    beforeDestroy() {
        window.removeEventListener('message', this.handleAuthMessage)
        window.removeEventListener('focus', this.handleWindowFocus)

        this.stopAuthStatusPolling()

        if (this.popupCheckInterval) {
            clearInterval(this.popupCheckInterval)
            this.popupCheckInterval = null
        }
    },
    methods: {
        goHomeHandler() {
            if (this.hasGenderSource) {
                this.$router.go(-1)
            } else {
                this.$router.push('/')
            }
        },
        openLink(type) {
            const ua = navigator.userAgent || navigator.vendor || window.opera

            const isMobile = /Android|iPhone|iPad|iPod/i.test(ua)
            const isApp = typeof window.ReactNativeWebView !== 'undefined'

            if (isMobile && isApp) {
                // mobile app
                this.$nativeBridge.postMessage({
                    action: 'openInAppBrowser',
                    value: `https://jj-api.vanillabridge.com/api/users/terms?term_type=${type}`,
                })
            } else {
                // not mobile app
                window.open(
                    `https://jj-api.vanillabridge.com/api/users/terms?term_type=${type}`,
                    'authPopup',
                    'width=500,height=600'
                )
            }
        },
        getTwoDaysAgoFormattedDate() {
            const date = new Date()
            date.setDate(date.getDate() - 2) // 2일 전으로 설정

            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0') // 월은 0부터 시작하니까 +1
            const day = String(date.getDate()).padStart(2, '0')

            return `${year}년 ${month}월 ${day}일`
        },
        handleAuthMessage(event) {
            // pc에서 인증 완료 콜백 처리
            if (!event.data || typeof event.data !== 'object' || event.data.source === 'react-devtools-content-script')
                return

            // console.log('[handleAuthMessage] called')
            // console.log('event.origin:', event.origin)
            // console.log('event.data:', event.data)
            // this.$toast.success(`handleAuthMessage called`)

            if (event.origin !== process.env.VUE_APP_API_URL.slice(0, -5)) return // 보안 체크

            // this.$toast.success(`handleAuthMessage called: ${event.data.type}`)
            if (event.data && event.data.type === 'auth_complete') {
                console.log('인증 완료 URL:', event.data.url)

                // 팝업(자식창)에게 수신 ACK 전달 (자식창이 스스로 close 할 수 있도록)
                try {
                    if (event.data && event.data.rid) this.lastAuthRid = event.data.rid
                    if (event.source && typeof event.source.postMessage === 'function') {
                        event.source.postMessage({ type: 'auth_received', rid: event.data.rid || null }, event.origin)
                    }
                } catch (e) {
                    console.warn('ACK 전송 실패:', e)
                }

                // 인증 완료 처리 로직 실행
                this.closeAuthPopup()
                // niceData 저장해야함
                const params = this.parseAuthData(event.data.url)

                if (params) {
                    this.$store.commit('setNiceData', params)
                }
            }
        },
        handleWindowFocus() {
            console.log('handleWindowFocus')
            // 인증 성공 postMessage 없이 포커스만 돌아온 경우 = 취소
            // if (!this.returnedFromPopup && authPopup === null) {
            if (!this.returnedFromPopup && authPopup === null && typeof window.ReactNativeWebView === 'undefined') {
                this.loading = false
                console.log('포커스 돌아옴 - 인증 취소로 간주')
            }
        },
        openAuthPopup(rid) {
            this.returnedFromPopup = false
            this.lastAuthRid = rid

            // RN 여부 = App 인지 여부 담아서 호출
            const isApp = typeof window.ReactNativeWebView !== 'undefined'

            authPopup = window.open(
                `${process.env.VUE_APP_API_URL}/v2/auths?from=${isApp ? 'app' : 'browser'}&rid=${encodeURIComponent(
                    rid
                )}`,
                'authPopup',
                'width=500,height=600'
            )

            if (this.popupCheckInterval) {
                clearInterval(this.popupCheckInterval)
            }

            this.popupCheckInterval = setInterval(() => {
                if (authPopup && authPopup.closed) {
                    clearInterval(this.popupCheckInterval)
                    this.popupCheckInterval = null
                    authPopup = null

                    if (!this.returnedFromPopup) {
                        /*
                         * postMessage를 받지 못했더라도 fallback polling이
                         * NICE 결과를 회수할 수 있으므로 polling은 중단하지 않는다.
                         *
                         * 기존 UX는 유지하기 위해 loading만 해제한다.
                         */
                        this.loading = false

                        console.log('인증창이 닫혔지만 결과 메시지를 받지 못함 - fallback polling 계속 진행')
                    }
                }

                // (가능하면) 팝업 URL 감시 — cross-origin이면 예외 발생하므로 try/catch
                if (authPopup) {
                    try {
                        const href = authPopup.location && authPopup.location.href

                        if (href && href.startsWith('about:')) {
                            console.warn('팝업이 about:* 로 이동했습니다:', href)
                        }
                    } catch (e) {
                        // cross-origin 상태에서는 정상적으로 예외 발생
                    }
                }
            }, 500)
        },
        closeAuthPopup() {
            this.returnedFromPopup = true
            this.loading = false
            if (authPopup) {
                try {
                    authPopup.close()
                } catch (e) {
                    console.warn('팝업 닫기 실패:', e)
                }
            }
        },

        goBackHandler() {
            this.$router.go(-1)
        },

        resetUtmLocalstorage() {
            localStorage.removeItem('GENDER_SOURCE')

            localStorage.removeItem('INTRO_VER')
            localStorage.removeItem('LANDING_VER')
            localStorage.removeItem('UTM_CHANNEL')
            localStorage.removeItem('UTM_MEDIUM')
            localStorage.removeItem('UTM_CAMPAIGN')
            localStorage.removeItem('UTM_ADSET')
            localStorage.removeItem('UTM_CONTENT')
        },

        async logUTM() {
            console.log('logUTM called')
            const INTRO_VER = localStorage.getItem('INTRO_VER') ? localStorage.getItem('INTRO_VER').toString() : null
            const LANDING_VER = localStorage.getItem('LANDING_VER')
                ? localStorage.getItem('LANDING_VER').toString()
                : null

            const UTM_CHANNEL = localStorage.getItem('UTM_CHANNEL')
                ? localStorage.getItem('UTM_CHANNEL').toString()
                : null
            const UTM_MEDIUM = localStorage.getItem('UTM_MEDIUM') ? localStorage.getItem('UTM_MEDIUM').toString() : null
            const UTM_CAMPAIGN = localStorage.getItem('UTM_CAMPAIGN')
                ? localStorage.getItem('UTM_CAMPAIGN').toString()
                : null
            const UTM_ADSET = localStorage.getItem('UTM_ADSET') ? localStorage.getItem('UTM_MEDIUM').toString() : null
            const UTM_CONTENT = localStorage.getItem('UTM_CONTENT')
                ? localStorage.getItem('UTM_CONTENT').toString()
                : null

            const DEVICE_ID = localStorage.getItem('DEVICE_ID') ? localStorage.getItem('DEVICE_ID').toString() : null
            const OS = this.getUserOS()

            try {
                const payload = {
                    landing_ver: LANDING_VER,
                    intro_ver: INTRO_VER,

                    utm_channel: UTM_CHANNEL,
                    utm_medium: UTM_MEDIUM,
                    utm_campaign: UTM_CAMPAIGN,
                    utm_adset: UTM_ADSET,
                    utm_content: UTM_CONTENT,

                    device_id: DEVICE_ID,
                    os: OS,
                }
                const res = await userService.createSignupFunnel(payload)
                if (res) {
                    this.resetUtmLocalstorage()
                }
            } catch (err) {
                console.error(err)
            }
        },
        async goNextPage() {
            console.log('goNextPage called')

            this.logUTM()

            this.$fbPixel.track('Contact')
            sendMetaTransition('Contact')

            this.loading = true
            this.hasFinished = false

            const ua = navigator.userAgent || navigator.vendor || window.opera

            const isMobile = /Android|iPhone|iPad|iPod/i.test(ua)
            const isApp = typeof window.ReactNativeWebView !== 'undefined'

            if (isMobile && isApp) {
                console.log('goNextPage is mobile & App installed')

                // 앱에서 본인인증 로직 태우기
                this.$nativeBridge.postMessage({
                    action: 'sendFirebaseEvent',
                    value: {
                        category: 'FirstPage_Click_NextBtn',
                        option: {
                            provider: this.$store.getters.payloads.signupData.provider || 'email',
                        },
                    },
                })

                // 한 번 인증 받아서 인증정보가 스토어에 남아있으면 그냥 진행 다시시도 (사실 이런 경우 자체가 생기면 안되긴 함)
                // 기존 인증 데이터가 정상적으로 남아 있다면 기존 동작 유지
                if (this.$store.getters.niceData) {
                    return this.finish(this.$store.getters.niceData)
                }
            }

            /*
             * browser / RN 모두 같은 rid를 사용한다.
             *
             * browser:
             *   URL parameter로 Rails auths#index에 전달
             *
             * RN:
             *   기존 앱이 rid를 전달할 수 없으므로
             *   prepareAuth()에서 저장한 Rails session으로 전달
             */
            const rid = this.generateAuthRid()

            this.lastAuthRid = rid

            try {
                await this.prepareAuth(rid)
            } catch (e) {
                /*
                 * fallback 준비 실패가 기존 정상 NICE 인증까지 막아서는 안 된다.
                 *
                 * RN에서는 이 경우 fallback은 동작하지 않지만,
                 * 기존 niceData 메시지 방식은 그대로 동작한다.
                 */
                console.error('[NICE] prepareAuth failed:', e)
            }

            // 인증 결과 polling 시작
            this.startAuthStatusPolling(rid)

            if (isMobile && isApp) {
                /*
                 * 기존 RN 앱에는 아무 변경 없음.
                 *
                 * RN은 기존과 동일하게 /api/v2/auths 를 열고,
                 * Rails가 session[:pending_auth_rid]로 rid를 복원한다.
                 */
                this.$nativeBridge.postMessage({
                    action: 'verification',
                })
            } else {
                console.log('goNextPage: is not RN App')

                this.openAuthPopup(rid)
            }
        },
        finish(niceData) {
            console.log('finish called', niceData)

            if (this.hasFinished) {
                console.log('중복 finish 호출 방지됨')
                return
            }

            if (!niceData) {
                console.warn('finish called without niceData')
                return
            }

            const signupData = this.$store.getters.payloads.signupData || {}

            if (!this.checkNiceData(signupData, niceData)) {
                return
            }

            /*
             * 유효한 인증 결과까지 확인된 이후에만 lock.
             *
             * RN message와 polling이 거의 동시에 도착하는 race를
             * 여기서 차단한다.
             */
            this.hasFinished = true
            this.returnedFromPopup = true

            this.stopAuthStatusPolling()

            console.log('checkNiceData passed', niceData)

            signupData.response_id = niceData.response_id

            this.$store.commit('setPayloads', {
                signupData,
            })

            this.createUser(signupData)
        },
        checkNiceData(signupData, niceData) {
            const checkStatus = status => {
                let errMsg = ''
                if (status === 'too_young')
                    errMsg = '바닐라브릿지에서는 미성년자를 위한 서비스를 제공하고 있지 않습니다. 양해 부탁드립니다.'
                if (status === 'duplicated') errMsg = '이미 가입된 핸드폰 번호입니다.'
                if (status === 'fail') errMsg = '본인 인증을 다시 시도해주세요.'

                if (errMsg) {
                    this.$toast.error(errMsg)
                    return false
                }
                return true
            }

            // const checkGender = niceGender => {
            //     const liar =
            //         (niceGender === '1' && signupData.gender.name === 'FEMALE') ||
            //         (niceGender === '0' && signupData.gender.name === 'MALE')
            //     if (liar)
            //         this.$toast.error('선택한 성별이 본인 인증을 통한 성별과 다릅니다. 처음부터 다시 진행해주세요.')
            //     return !liar
            // }

            // return checkStatus(niceData.status) && checkGender(niceData.gender)
            return checkStatus(niceData.status)
        },
        getUserOS() {
            const platform = navigator.platform.toLowerCase()
            const userAgent = navigator.userAgent.toLowerCase()

            if (/android/.test(userAgent)) return 'Android'
            if (/iphone|ipad|ipod/.test(userAgent)) return 'iOS'
            if (platform.includes('win') || /windows/.test(userAgent)) return 'Windows'
            if (platform.includes('mac') || /macintosh/.test(userAgent)) return 'macOS'
            if (platform.includes('linux') || /linux/.test(userAgent)) return 'Linux'

            return 'Unknown'
        },

        async createUser(signupData) {
            console.log('createUser called', signupData)
            const device = this.$store.getters.device

            try {
                this.loading = true

                await this.initTerms()

                const DEVICE_ID = localStorage.getItem('DEVICE_ID') ? localStorage.getItem('DEVICE_ID').toString() : ''
                const { user } = await userService.create({ response_id: signupData.response_id, device_id: DEVICE_ID })

                // 사진 업로드하는 시간을 고려하여 사진은 별도로 업로드
                // userService.uploadPhotos(user.id, this.photosPayload(signupData.photos, user.token))

                // 회원 생성 시점에 가입 완료로 간주, 이벤트 전송
                // const { provider, gender } = this.$store.getters.payloads.signupData

                // this.$nativeBridge.postMessage({
                //     action: 'sendFirebaseEvent',
                //     value: {
                //         category: 'Complete_Signup',
                //         option: {
                //             provider: provider || 'email',
                //             gender: gender.name === 'MALE' ? 0 : 1,
                //         },
                //     },
                // })

                // 그냥 로그인 시켜버리가
                const header = {
                    'X-User-Email': user.email,
                    'X-User-Token': user.token,
                    'X-User-Role': 'user',
                    'X-User-OS': device ? device.os : this.getUserOS(),
                    'X-User-Agent': device ? JSON.stringify(device) : navigator.userAgent,
                }
                axios.setHeader(header)
                this.$store.commit('setHeader', header)

                try {
                    await this.$store.dispatch('afterAuthCallbacks')
                } catch (e) {
                    Vue.prototype.$toast.error(e.data.msg)
                    return Promise.reject(e)
                }

                this.$fbPixel.track('InitiateCheckout')
                sendMetaTransition('InitiateCheckout')

                this.$router.push('/apply/form')
            } catch (e) {
                console.log('createUser catch called', e)
                if (e.data.key === 'auth_validation_expired') {
                    this.$store.commit('setNiceData', null)
                }
                if (e.data.key === 'blocked_user') {
                    this.$modal.basic({
                        title: 'MODAL_DEFAULT_TITLE',
                        body: e.data.msg,
                        buttons: [
                            {
                                label: 'CONFIRM',
                                class: 'btn-primary',
                            },
                        ],
                    })
                } else if (e.data.key === 'already_exists') {
                    // 기존 계정으로 로그인 처리하고
                    // 이거 로그인 처리가 제대로 되지 않는듯!
                    const header = {
                        'X-User-Email': e.data.email,
                        'X-User-Token': e.data.token,
                        'X-User-Role': 'user',
                        'X-User-OS': device ? device.os : this.getUserOS(),
                        'X-User-Agent': device ? JSON.stringify(device) : navigator.userAgent,
                    }
                    axios.setHeader(header)
                    this.$store.commit('setHeader', header)

                    try {
                        await this.$store.dispatch('afterAuthCallbacks')
                    } catch (e) {
                        Vue.prototype.$toast.error(e.data.msg)
                        return Promise.reject(e)
                    }

                    if (e.data.profile.status === 'created') {
                        // part1 이어서 진행
                        const idx = await this.$modal.basic({
                            title: 'MODAL_DEFAULT_TITLE',
                            body:
                                '이전에 가입 심사를 하다가 그만두신 적이 있네요! 그만두었던 항목부터 입력을  다시 시작합니다.',
                            showCloseButton: false,
                            buttons: [
                                {
                                    label: '확인',
                                    class: 'btn-primary',
                                },
                            ],
                        })
                        // console.log('idx', idx)
                        if (idx === 0) {
                            this.$router.push('/apply/form')
                        }
                    } else {
                        // 홈화면(/chats)으로 보내기
                        let msg = '이미 가입하신 적이 있네요! 바로 홈화면으로 이동합니다.'
                        if (
                            ['complete_profile', 'complete_verify', 'ongoing_verification'].indexOf(
                                e.data.profile.status
                            ) !== -1
                        ) {
                            msg =
                                '가입 심사 이력이 존재합니다. 나머지 가입 절차를 완료해주세요. 가입 화면으로 이동합니다.'
                        } else if (['judging', 'judged'].indexOf(e.data.profile.status) !== -1) {
                            msg =
                                "최종 가입 심사중입니다. 잠시만 기다려주세요. 궁금하신 점은 '가입도우미'에게 문의해주세요."
                        } else if (['confirmed'].indexOf(e.data.profile.status) !== -1) {
                            msg =
                                '가입 승인 되어 매니저가 배정되었습니다. 굿퍼슨 앱을 설치하시면 중요한 알림을 놓치지 않을 수 있어요! 홈 화면으로 이동합니다.'
                        }
                        // this.$toast.success(msg)
                        // this.$router.push('/chats')

                        const idx = await this.$modal.basic({
                            title: 'MODAL_DEFAULT_TITLE',
                            body: msg,
                            showCloseButton: false,
                            buttons: [
                                {
                                    label: '확인',
                                    class: 'btn-primary',
                                },
                            ],
                        })
                        // console.log('idx', idx)
                        if (idx === 0) {
                            this.$router.push('/chats')
                        }
                    }
                    // this.$toast.error(e.data)
                } else {
                    this.$toast.error(e.data)
                }
            } finally {
                this.loading = false
            }
        },
        async initTerms() {
            await this.$store.dispatch('loadTerms')
            const { terms } = this.$store.getters.terms || {}
            this.terms = terms
        },

        generateAuthRid() {
            if (window.crypto && typeof window.crypto.randomUUID === 'function') {
                return window.crypto.randomUUID()
            }

            if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
                const values = new Uint32Array(4)
                window.crypto.getRandomValues(values)

                return Array.from(values)
                    .map(value => value.toString(16).padStart(8, '0'))
                    .join('')
            }

            return `${Date.now()}_${Math.random().toString(16).slice(2)}_${Math.random().toString(16).slice(2)}`
        },

        async prepareAuth(rid) {
            const url = `${process.env.VUE_APP_API_URL}/v2/auths/prepare?rid=${encodeURIComponent(rid)}`

            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
            })

            if (!response.ok) {
                throw new Error(`prepareAuth failed: ${response.status}`)
            }

            const data = await response.json()

            if (!data || data.status !== 'ok' || data.rid !== rid) {
                throw new Error('prepareAuth invalid response')
            }

            console.log('[NICE] prepareAuth success:', rid)
        },

        parseAuthData(rawData) {
            if (!rawData) return null

            const params = {}

            const str = String(rawData).replace(/&amp;/g, '&')
            const regex = /[?&]?([^=#&]+)=([^&#]*)/g

            let match

            while (true) {
                match = regex.exec(str)

                if (!match) break

                params[match[1]] = match[2]
            }

            return params
        },

        startAuthStatusPolling(rid) {
            this.stopAuthStatusPolling()

            this.authStatusPollCount = 0

            // NICE 인증 도중부터 polling을 시작한다.
            // 정상 메시지 전달이 되면 finish()에서 자동 중단된다.
            this.authStatusPollInterval = setInterval(async () => {
                if (this.hasFinished) {
                    this.stopAuthStatusPolling()
                    return
                }

                // 2초 * 300회 = 최대 약 10분
                this.authStatusPollCount += 1

                if (this.authStatusPollCount > 300) {
                    console.warn('[NICE] fallback polling timeout:', rid)
                    this.stopAuthStatusPolling()
                    return
                }

                try {
                    const url = `${process.env.VUE_APP_API_URL}/v2/auths/status?rid=${encodeURIComponent(rid)}`

                    const response = await fetch(url, {
                        method: 'GET',
                        credentials: 'include',
                    })

                    if (!response.ok) {
                        console.warn('[NICE] status response error:', response.status)
                        return
                    }

                    const result = await response.json()

                    if (!result || result.status !== 'completed') return

                    console.log('[NICE] fallback result recovered:', rid)

                    const niceData = this.parseAuthData(result.data)

                    if (!niceData || !niceData.response_id) {
                        console.warn('[NICE] fallback result invalid:', result)
                        return
                    }

                    this.stopAuthStatusPolling()

                    // 기존 RN/Web 정상 경로와 동일하게 Vuex에 넣는다.
                    // watcher -> finish() 경로를 그대로 재사용.
                    this.$store.commit('setNiceData', niceData)
                } catch (e) {
                    // 인증 진행 중 네트워크 순간 오류 때문에 polling 자체를 죽이지 않는다.
                    console.warn('[NICE] fallback polling error:', e)
                }
            }, 2000)
        },

        stopAuthStatusPolling() {
            if (this.authStatusPollInterval) {
                clearInterval(this.authStatusPollInterval)
                this.authStatusPollInterval = null
            }

            this.authStatusPollCount = 0
        },
    },
}
</script>

<style lang="scss" scoped>
.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-message {
        margin-top: 16px;
        color: black;
        font-size: 14px;
    }
}

.apply-page {
    padding-left: 20px;
    padding-right: 20px;
}
.section-one {
    margin: calc(150px - 56px) 0 calc(170px - 30px - 12px) 0;

    .title-box {
        margin-bottom: 35px;

        .icon {
            margin-bottom: 8px;
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }

        .title {
            color: var(--Gray-313131, #313131);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%; /* 33.6px */
        }
    }

    .percent-box {
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: center;
        position: relative;

        &.version-one {
            // background-color: #E6EBFF;
            // backdrop-filter: blur(16.75px) opacity(80%);

            .background {
                position: absolute;
                width: 245px;
                height: 100%;
                z-index: 0;

                background-color: #e6ebff;
                opacity: 0.8;
                filter: blur(16.75px);
            }
        }
        &.version-two {
        }

        .number {
            z-index: 1;
            color: #3452d5;
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 70px;
            font-style: normal;
            font-weight: 700;
            line-height: 70%; /* 49px */
            letter-spacing: 5px;
        }

        .symbol {
            z-index: 1;
            color: #3452d5;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 70%;
            letter-spacing: 5px;
        }
    }

    .desc {
        margin-top: 24px;
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 22.5px */
    }
}
.section-two {
    .btn-desc {
        color: var(--Grey-787878, #787878);
        text-align: left;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 22.5px */

        width: 300px;
        margin: 0 auto;

        > p {
            text-indent: -16px;
        }
        > p:not(:first-child) {
            margin-top: 4px;
        }
    }

    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        background: var(--Green, #0a7);
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 40px 0 20px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
        }
    }

    .btn-desc-sec {
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%; /* 16.5px */

        .link {
            color: var(--Grey-787878, #787878);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-decoration-skip-ink: none;
            text-decoration-thickness: auto;
            text-underline-offset: auto;
            text-underline-position: from-font;
        }
    }
}
.section-three {
    .title {
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 300;
        line-height: 100%; /* 13px */
    }

    .list-box {
        width: 100%;
        height: auto;
    }
}
</style>
